import React from 'react';
import FteIobWarnings from './FteIobWarnings';
import FteMonthSelector from './FteMonthSelector';

export default function FteToolbar({ warnings, year, month, onChangeMonth }) {
  return (
    <div className='d-flex align-items-center justify-content-between flex-wrap gap-3 w-100 px-3' style={{ marginTop: '20px' }}>
      <FteIobWarnings warnings={warnings} />
      <FteMonthSelector year={year} month={month} onChangeMonth={onChangeMonth} />
    </div>
  );
}
